<template>
  <Panel title="Add additional API.expert collections" class="panel-default">
    <template #header="{ title }">
      <h3 class="panel-title">
        <a
          v-tooltip="expand ? 'Shrink view' : 'Expand view'"
          :aria-label="expand ? 'Shrink view' : 'Expand view'"
          @click.prevent="expand = !expand"
          @keyup.enter="expand = !expand"
        >
          <i v-if="expand" class="glyphicon glyphicon-resize-small" />
          <i v-else class="glyphicon glyphicon-resize-full" />
        </a>
        {{ ' ' }}
        <a
          v-tooltip="'API.expert'"
          @click.prevent="expand = !expand"
          @keyup.enter="expand = !expand"
        >
          <img style="width: 20px; height: 20px" src="/img/api-expert-icon.svg" alt="API.expert" />
          {{ title }}
        </a>
        <span v-if="!expand" class="text-normal">
          | <a @click.prevent="expand = !expand" @keyup.enter="expand = !expand">More info...</a>
        </span>
      </h3>
    </template>
    <template v-if="expand" #default>
      <ApiExpert />
    </template>
  </Panel>
</template>

<script>
// eslint-disable-next-line import/extensions
import Panel from '../Panel.vue';
import ApiExpert from '../ApiExpert.vue';

export default {
  name: 'ApiExpertPanel',
  components: {
    Panel,
    ApiExpert,
  },
  props: {
    initialExpand: {
      type: Boolean,
      required: false,
      default: true,
    },
    triggerExpand: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      expand: this.initialExpand,
    };
  },
  watch: {
    triggerExpand(val) {
      if (val) {
        this.expand = true;
      }
    },
    expand(val) {
      this.$emit('expanded', val);
    },
  },
};
</script>
